/**
 * @generated SignedSource<<2a0e2fa4fd6ed0b3f3c37526ce9e96f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddIncludeTreeStartedDispatchConditionInput = {
  clientMutationId?: string | null;
  messageDispatchId: string;
  rootNodeIds: ReadonlyArray<string>;
};
export type useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation$variables = {
  input: AddIncludeTreeStartedDispatchConditionInput;
};
export type useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation$data = {
  readonly Admin: {
    readonly Message: {
      readonly addIncludeTreeStartedDispatchCondition: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation = {
  response: useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation$data;
  variables: useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Message",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "AddIncludeTreeStartedDispatchConditionPayload",
            "kind": "LinkedField",
            "name": "addIncludeTreeStartedDispatchCondition",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "26cbbf08060704d8a601ca969ac8af7d",
    "id": null,
    "metadata": {},
    "name": "useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation",
    "operationKind": "mutation",
    "text": "mutation useDispatchConditions_AddIncludeTreeStartedDispatchConditionMutation(\n  $input: AddIncludeTreeStartedDispatchConditionInput!\n) {\n  Admin {\n    Message {\n      addIncludeTreeStartedDispatchCondition(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "20a194322b1b16f4f42326b7674e6477";

export default node;
